import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SimpleOrder {
  id: string;
  supplierName?: string | null;
  supplierCode?: string | null;
  deliveryDate?: string | null;
  status?: string | null;
  productCount?: number | null;
}

export const useOrder = (orderId?: string) => {
  return useQuery({
    queryKey: ["order", orderId],
    queryFn: async (): Promise<SimpleOrder | null> => {
      if (!orderId) return null;
      const { data, error } = await supabase
        .from("orders")
        .select("*")
        .eq("id", orderId)
        .maybeSingle();
      if (error) throw error;
      return (data as any) || null;
    },
    enabled: !!orderId,
    staleTime: 30000,
    retry: false,
  });
};
